import script from "./floatButton2.vue?vue&type=script&setup=true&lang=ts"
export * from "./floatButton2.vue?vue&type=script&setup=true&lang=ts"

import "./floatButton2.vue?vue&type=style&index=0&id=6424883e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6424883e"]])

export default __exports__